import React from 'react';
import {
  Box,
  Typography,
  Button,
  Switch,
  FormControlLabel,
  Fade,
} from '@material-ui/core';
import {
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
  PlayArrow as PlayIcon,
} from '@material-ui/icons';
import { useDeploymentStyles } from '../../styles/deployment';

interface DeploymentControlsProps {
  isLocked: boolean;
  onLockToggle?: () => void;
  onDeploy?: () => void;
  title: string;
}

export const DeploymentControls = ({
  isLocked,
  onLockToggle,
  onDeploy,
  title,
}: DeploymentControlsProps) => {
  const classes = useDeploymentStyles();

  const handleDeploy = () => {
    if (onDeploy) {
      onDeploy();
    } else {
      alert(`Starting deployment for ${title}`);
    }
  };

  return (
    <Box className={classes.lockSwitch}>
      <FormControlLabel
        control={
          <Switch checked={!isLocked} onChange={onLockToggle} color="primary" />
        }
        label={
          <Box display="flex" alignItems="center">
            {isLocked ? (
              <LockIcon style={{ marginRight: 4, fontSize: 18 }} />
            ) : (
              <LockOpenIcon style={{ marginRight: 4, fontSize: 18 }} />
            )}
            <Typography variant="body2" style={{ fontWeight: 500 }}>
              {isLocked ? 'Deployment Locked' : 'Deployment Unlocked'}
            </Typography>
          </Box>
        }
      />
      <Fade in={!isLocked} timeout={300}>
        <Box>
          {!isLocked && (
            <Button
              className={`${classes.deploymentButton} unlocked`}
              variant="contained"
              fullWidth
              startIcon={<PlayIcon />}
              onClick={handleDeploy}
            >
              Deploy {title}
            </Button>
          )}
        </Box>
      </Fade>
    </Box>
  );
};
